// Library Imports
import React, { useEffect, useCallback } from 'react';
import { Box, Image } from 'grommet';

// Core Imports
import useQuery from 'granite-admin/utils/useQuery';
import { getCookie } from 'granite-admin/utils/storage';
import EventEmitter from 'granite-admin/utils/event-emitter';
// Application Imports
import { installShopifyWindow } from 'shopifyConfig/controllers/shopifyConfig.js';
import quiversLogo from 'pages/shopifyConfig/assets/quivers.png';
// import { STRINGS } from 'pages/shopifyConfig/strings.js';
const quiversadminUrl = process.env.REACT_APP_QUIVERS_ADMIN_URL;
const choosebusiness = process.env.REACT_APP_REDIRECT_CHOOSE_BUSINESS;
const ShopifyMiddlewareUrl = process.env.REACT_APP_SHOPIFY_MIDDLEWARE_URL;

const eventEmitter = new EventEmitter();

const ExternalRedirect = () => {
  // const plugin_id = getCookie('id');
  // const business_id = getCookie('business');

  const { query } = useQuery();

  const handleAnchorClick = useCallback(
    async (url, checkWindowClose = false, temp) => {
      const refId = temp?.ref_id;
      const pluginId = temp?.plugin_id;
      if (!checkWindowClose && refId && pluginId) {
        url = `${quiversadminUrl}#/${refId}/app_settings/${pluginId}`;
      }
      // Open the URL in the same window
      // const newWindow = window.open(url, '', 'width=800,height=600');
      window.location.href = url;
    },
    [], // Dependencies array
  );

  const handleCloseShopify = useCallback(temp => {
    // const subdomain = query.shop;
    const apiUrl = `${ShopifyMiddlewareUrl}connect/?id=${temp?.id}&ref_id=${temp?.ref_id}&shop=${temp?.shop}`;
    window.location.href = apiUrl;
    // if (temp?.id && temp?.ref_id) {
    //   closeShopifyWindow(eventEmitter, {
    //     id: temp?.id,
    //     ref_id: temp?.ref_id,
    //     shop: subdomain,
    //   });
    // }
  }, []);

  const handleInstallShopify = useCallback(async () => {
    const subdomain = query.shop;

    if (subdomain) {
      const temp = await installShopifyWindow(eventEmitter, { shop: subdomain });
      const timestamp = Date.now();
      // get cookie values
      let business_ref_id = getCookie('business');
      let quivers_plugin_id = getCookie('id');
      if (window.opener) {
        if (!business_ref_id || !quivers_plugin_id) {
          const src_iframe_url = new URL(window.opener.location.href);
          business_ref_id = src_iframe_url.searchParams.get('business');
          quivers_plugin_id = src_iframe_url.searchParams.get('id');
        }
      }

      //

      if (temp.is_app_connected_with_quivers) {
        // send to app page
        window.location.replace(`${quiversadminUrl}#/${temp?.ref_id}/app_settings/${temp?.plugin_id}`);
      } else if (business_ref_id && quivers_plugin_id) {
        // const connect_url = `${ShopifyMiddlewareUrl}connect?id=${quivers_plugin_id}&ref_id=${business_ref_id}&shop=${query.shop}`;
        const connect_api_params = {
          id: quivers_plugin_id,
          ref_id: business_ref_id,
          shop: query.shop,
        };
        handleCloseShopify(connect_api_params);
      } else {
        handleAnchorClick(
          `${choosebusiness}choose_business?destination=app_install/EcommShopify?name=${query.shop}%26ts=${timestamp}`,
          true, // Enable window close check for this button
          temp,
        );
      }

      // setInstalled(temp);
    }
  }, [query.shop, handleCloseShopify, handleAnchorClick]);

  useEffect(() => {
    setTimeout(() => {
      handleInstallShopify();
    }, 1000);
  }, [handleInstallShopify, handleCloseShopify]);

  return (
    <Box align="center" pad="large" justify="center" background="white" gap="medium" height="70%">
      <Image src={quiversLogo} height="100px" width="100px" />

      {/* {installed &&
 (!installed?.is_app_connected_with_quivers ? (
 <Button
 label={<Text size="xlarge">{STRINGS?.CONNECT_LABEL}</Text>}
 onClick={() =>
 handleAnchorClick(
 `${choosebusiness}choose_business?destination=app_install/EcommShopify?name=${query.shop}`,
 true, // Enable window close check for this button
 )
 }
 />
 ) : (
 <Button
 label={<Text size="xlarge">{STRINGS?.MANAGE_LABEL}</Text>}
 onClick={() => handleAnchorClick(quiversAdmin)}
 />
 ))} */}
    </Box>
  );
};

export default ExternalRedirect;
